import { fetchToken } from "../../../../../common/FetchCookie"
import { BASE_URL, EMPLOYER, EMPLOYER_SEARCHED_CANDIDATES } from "../../../../../common/URLs"

const API_BASE_URL = `${BASE_URL}/${EMPLOYER}/${EMPLOYER_SEARCHED_CANDIDATES}`

export const fetchSearchedCandidates = async (
  notice_period,
  work_status,
  experience_min,
  experience_max,
  skills,
  locations,
  educations,
  candidate_gender,
  page = 1,
) => {
  const queryObject = {
    notice_period: notice_period || 0,
    experience_min: experience_min || 0,
    experience_max: experience_max || 0,
    page: page,
    ...(skills?.length ? { skills: JSON.stringify(skills) } : {}),
    ...(locations?.length ? { locations: JSON.stringify(locations) } : {}),
    ...(educations?.length ? { educations: JSON.stringify(educations) } : {}),
  }

  // Add conditional fields
  if (work_status) {
    queryObject.work_status = work_status
  }
  if (candidate_gender) {
    queryObject.candidate_gender = candidate_gender
  }

  const query = new URLSearchParams(queryObject).toString()
  const url = `${API_BASE_URL}?${query}`

  try {
    const token = await fetchToken()

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    })

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`)
    }

    const data = await response.json()
    return data
  } catch (error) {
    throw error
  }
}